const verticalPaddingCls = "_yr2v124mzj8";

export { verticalPaddingCls };
import "./VerticalPadding.linaria.module.css";
//# sourceMappingURL=VerticalPadding.js.map
